export default __webpack_public_path__ + "static/media/people.778bb5df.jpg";